import { graphql, useStaticQuery } from "gatsby";
import imgdefault from "../../images/icon.png";
const useSeo = ({ description, title, img }) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `,
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata.title;
  const defaultImg = img || imgdefault;

  return { metaDescription, defaultTitle, defaultImg };
};

export default useSeo;
